import { toast } from 'sonner';
import VARIANT_COMPONENTS from './registry';
import SnackbarDefault from './SnackbarDefault';

const DEFAULT_DURATION = 5000;

export function enqueueSnackbar(message, options = {}) {
    const { variant, key, persist = false, ...rest } = options;

    const Component = (variant && VARIANT_COMPONENTS[variant]) || SnackbarDefault;

    const toastOptions = { duration: persist ? Infinity : DEFAULT_DURATION };
    if (key !== undefined) {
        toastOptions.id = key;
    }

    return toast.custom((id) => <Component id={id} message={message} {...rest} />, toastOptions);
}

export function closeSnackbar(key) {
    if (key === undefined) {
        toast.dismiss();
    } else {
        toast.dismiss(key);
    }
}

export function useSnackbar() {
    return { enqueueSnackbar, closeSnackbar };
}
